export function getWebhookErrorCategory({
  pendingRetryCount,
  lastFailureStatusCode,
  lastFailureSnippet,
} = {}) {
  const retryCount = Number(pendingRetryCount ?? 0);
  const statusCode = Number(lastFailureStatusCode);
  const snippet = String(lastFailureSnippet || "").trim().toLowerCase();

  if (retryCount > 0) {
    return "Retrying";
  }

  if (statusCode === 401 || statusCode === 403) {
    return "Auth";
  }

  if (statusCode === 404) {
    return "NotFound";
  }

  if (Number.isFinite(statusCode) && statusCode >= 500) {
    return "ServerError";
  }

  if (
    snippet.includes("timeout") ||
    snippet.includes("timed out") ||
    snippet.includes("unreachable") ||
    snippet.includes("connection")
  ) {
    return "Connectivity";
  }

  return "Unknown";
}
